<div
  class="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-6 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-2xl max-h-[92vh] bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 overflow-hidden flex flex-col animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-start justify-between gap-4">
      <div class="min-w-0">
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">receipt_long</span>
          รายละเอียด Web Stamp
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium truncate">
          {{ item.rateName || 'ส่วนลด' }}
          <span *ngIf="item.license" class="text-amber-600 dark:text-amber-400"> · {{ item.license }}</span>
        </p>
      </div>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 shrink-0 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar px-6 md:px-8 py-6 space-y-5">
      <!-- Proof image -->
      <div *ngIf="item.pictureUrl"
        class="rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60">
        <button type="button" (click)="onOpenImage()"
          class="relative w-full group cursor-zoom-in border-none bg-transparent p-0 block">
          <img [src]="item.pictureUrl" alt="หลักฐาน stamp"
            class="w-full max-h-56 object-cover transition-transform duration-500 group-hover:scale-[1.02]"
            (error)="$any($event.target).src='img/notfound.jpg'">
          <div class="absolute inset-0 bg-gradient-to-t from-slate-900/50 via-transparent to-transparent opacity-80"></div>
          <span class="absolute bottom-3 right-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-white/90 dark:bg-slate-900/90 text-xs font-bold text-slate-700 dark:text-slate-200 shadow-sm">
            <span class="material-icons text-[16px]">zoom_in</span>
            ขยายรูป
          </span>
        </button>
      </div>

      <div *ngIf="!item.pictureUrl"
        class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 px-4 py-8 flex flex-col items-center text-slate-400 gap-2">
        <span class="material-icons text-3xl opacity-50">image_not_supported</span>
        <span class="text-sm font-medium">ไม่มีรูปหลักฐาน</span>
      </div>

      <!-- Meta grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div class="rounded-2xl bg-amber-50/70 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/40 p-4">
          <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">ทะเบียน</p>
          <p class="mt-1 text-lg font-black text-slate-800 dark:text-amber-100 tracking-wide">
            {{ item.license || '—' }}
          </p>
        </div>
        <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 p-4">
          <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">เวลา stamp</p>
          <p class="mt-1 text-sm font-bold text-slate-800 dark:text-slate-100 tabular-nums">
            {{ formatStampTime(item.stampTime) }}
          </p>
        </div>
      </div>

      <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 divide-y divide-slate-100 dark:divide-slate-700/80 text-sm">
        <div class="flex justify-between gap-4 px-4 py-3">
          <span class="text-slate-400 font-medium shrink-0">ชื่อส่วนลด</span>
          <span class="font-bold text-slate-700 dark:text-slate-200 text-right">{{ item.rateName || '—' }}</span>
        </div>
        <div class="flex justify-between gap-4 px-4 py-3">
          <span class="text-slate-400 font-medium shrink-0">ประเภทรถ</span>
          <span class="font-bold text-slate-700 dark:text-slate-200 text-right">{{ item.vehicleTypeName || '—' }}</span>
        </div>
        <div class="flex justify-between gap-4 px-4 py-3">
          <span class="text-slate-400 font-medium shrink-0">ผู้ให้ส่วนลด</span>
          <span class="font-bold text-slate-700 dark:text-slate-200 text-right">{{ item.userDisplayName || '—' }}</span>
        </div>
        <div class="flex justify-between gap-4 px-4 py-3">
          <span class="text-slate-400 font-medium shrink-0">Card Code</span>
          <span class="font-mono font-bold text-slate-700 dark:text-slate-200 text-right break-all">{{ item.cardCode || '—' }}</span>
        </div>
        <div class="flex justify-between gap-4 px-4 py-3">
          <span class="text-slate-400 font-medium shrink-0">Gate</span>
          <span class="font-bold text-slate-700 dark:text-slate-200 text-right">{{ item.gateId || '—' }}</span>
        </div>
      </div>

      <!-- Full remark -->
      <div>
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 flex items-center gap-1.5">
          <span class="material-icons text-[16px] text-amber-500">notes</span>
          หมายเหตุ
        </p>
        <div
          class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900/40 px-4 py-4 min-h-[96px] text-sm font-medium text-slate-700 dark:text-slate-200 whitespace-pre-wrap break-words leading-relaxed">
          {{ item.remark?.trim() ? item.remark : '—' }}
        </div>
      </div>
    </div>

    <div class="flex-none px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end">
      <button type="button" (click)="onClose()"
        class="h-[46px] px-6 rounded-2xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/40 dark:shadow-none transition-all border-none cursor-pointer">
        ปิด
      </button>
    </div>
  </div>
</div>
